"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PropertyTypes = _interopRequireDefault(require("../constants/PropertyTypes"));

var assignValueToProperty = function assignValueToProperty(property, update) {
  if (typeof property === "string") {
    return (0, _defineProperty2.default)({}, property, update ? update.get(property) : undefined);
  } else if ((0, _typeof2.default)(property) === "object") {
    if (property.type === _PropertyTypes.default.SIMPLE) {
      return (0, _defineProperty2.default)({}, property.key, update ? update.get(property.key) : undefined);
    } else if (property.type === _PropertyTypes.default.ORDERED_MAP) {
      return (0, _defineProperty2.default)({}, property.key, update ? update.get(property.key) : undefined);
    } else if (property.type === _PropertyTypes.default.NESTED) {
      return (0, _defineProperty2.default)({}, property.key, property.children.reduce(function (acc, child) {
        return Object.assign(acc, assignValueToProperty(child, update[property.key]));
      }, {}));
    }
  }

  return {};
};

var _default = function _default(properties, current, update) {
  return current.merge(properties.reduce(function (acc, property) {
    return Object.assign(acc, assignValueToProperty(property, update));
  }, {}));
};

exports.default = _default;
module.exports = exports.default;